// ===========================================================================
// Module I — New Member Onboarding
// Constantes y enums del módulo.
// ===========================================================================

/** Locations disponibles (mismas keys que los dumps de DataDashCareManager). */
export const LOCATIONS = [
  { key: "fort_myers", label: "Fort Myers" },
  { key: "fort_pierce", label: "Fort Pierce" },
  { key: "hialeah", label: "Hialeah" },
  { key: "immokalee", label: "Immokalee" },
  { key: "lake_worth", label: "Lake Worth" },
  { key: "lehigh_acres", label: "Lehigh Acres" },
  { key: "lehigh_acres_5705", label: "Lehigh Acres 5705" },
  { key: "naples", label: "Naples" },
  { key: "naples_5262", label: "Naples 5262" },
  { key: "port_st_lucie", label: "Port St. Lucie" },
];

export const DEFAULT_LOCATION = "fort_myers";

/**
 * Pasos del journey de onboarding, en orden
 * (espejo de outreach.TAB_ONBOARDING — journey del nuevo miembro).
 */
export const CHECKLIST_STEPS = [
  { key: "welcomeCall", label: "Welcome call" },
  { key: "recordsRequest", label: "Records request" },
  { key: "firstAppointment", label: "First appointment" },
  { key: "hraCompleted", label: "HRA completed" },
];

/** Etapa del journey derivada del checklist. */
export const STAGE_META = {
  NOT_STARTED: { label: "Not started", tone: "crit" },
  WELCOME_SENT: { label: "Welcome done", tone: "warn" },
  RECORDS_REQUESTED: { label: "Records requested", tone: "info" },
  APPOINTMENT_SET: { label: "First appt done", tone: "info" },
  ONBOARDED: { label: "Onboarded", tone: "ok" },
};

/** Deriva la etapa desde el checklist (primer paso incompleto define la etapa). */
export function stageFor(checklist) {
  if (!checklist.welcomeCall) return "NOT_STARTED";
  if (!checklist.recordsRequest) return "WELCOME_SENT";
  if (!checklist.firstAppointment) return "RECORDS_REQUESTED";
  if (!checklist.hraCompleted) return "APPOINTMENT_SET";
  return "ONBOARDED";
}
